import { render, staticRenderFns } from "./ReportDeclare.vue?vue&type=template&id=44a69c7c&"
import script from "./ReportDeclare.vue?vue&type=script&lang=js&"
export * from "./ReportDeclare.vue?vue&type=script&lang=js&"
import style0 from "./ReportDeclare.vue?vue&type=style&index=0&id=44a69c7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports